export enum NavIdsEnum {
  HERO = 'hero',
  TOOLS = 'tools',
  TEAM = 'team',
  PLANS = 'plans',
  ECOSYSTEM = 'ecosystem',
}

export const NAV_ITEMS = [
  {
    name: 'Início',
    id: NavIdsEnum.HERO,
  },
  {
    name: 'Ferramentas',
    id: NavIdsEnum.TOOLS,
  },
  {
    name: 'Quem faz',
    id: NavIdsEnum.TEAM,
  },
  {
    name: 'Planos',
    id: NavIdsEnum.PLANS,
  },
  {
    name: 'Ecossistema',
    id: NavIdsEnum.ECOSYSTEM,
  },
];
